<script>
import { courseListMethod } from '@state/helpers'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      show: true,
    }
  },
  methods: {
    ...courseListMethod,
    deleteEvent() {
      const calendarEventData = {
        id: this.data._id,
      }
      this.deleteCalendarEvent({ calendarEventData }).then((data) => {
        this.isLoading = false
        this.$bvToast.toast('Event Deleted Successfully', {
          title: `Success`,
          toaster: 'b-toaster-top-right',
          solid: true,
          variant: 'success',
          appendToast: false,
        })
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      })
    },
  },
}
</script>
<style>
.btn-secondary {
  color: #545b62 !important;
  background-color: white !important;
  border-color: #ced4da !important;
}
.btn-primary {
  color: white !important;
}
</style>
<template>
  <div class="alert">
    <b-modal
      id="delete-modal"
      v-model="show"
      title="delete"
      ok-title="Delete"
      :hide-footer="false"
      @ok="deleteEvent"
    >
      <template v-slot:modal-title>
        <h4>Delete</h4>
      </template>
      <p>Are you sure you want to delete the {{ data.title }} event?</p>
    </b-modal>
  </div>
</template>
